module.exports = __webpack_public_path__ + "static/media/scholarship-2.8d946485.jpg";